module.exports = __webpack_public_path__ + "media/images/bdo-429a3f2e5b31c262dc7b77aabea78d35.png";